export class StudentActiveSummary {
    unAssignedStudents: number;  
    activeActiveStudents: number;
    activeInActiveStudents: number;
    inActiveActiveStudents: number;
    inActiveInActiveStudents: number;
}
